import { render } from "./oneKeyVoucher.vue?vue&type=template&id=0f4dca18&scoped=true"
import script from "./oneKeyVoucher.vue?vue&type=script&lang=js"
export * from "./oneKeyVoucher.vue?vue&type=script&lang=js"

import "./oneKeyVoucher.vue?vue&type=style&index=0&id=0f4dca18&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4dca18"]])

export default __exports__